export const routes = {
  home: '/',
  onboarding: '/onboarding',
  today: '/today',
  breakout: '/breakout',
  imClose: '/im-close',
  momentum: '/momentum',
  settings: '/settings',
  auth: '/auth',
  authCallback: '/auth/callback',
  authHop: '/auth/hop',
} as const;
